import React, { useEffect, useState } from 'react';
import {
    Alert,
    Button,
    Col,
    Form,
    Modal,
    Row,
    Spinner,
    Toast,
    ToastContainer,
} from 'react-bootstrap';
import './patientList.css';
import { formatDate, getAge, matchEmails } from '../../helper';
import { useAddPatientMutation, useEditUserMutation } from './patientApi';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import { useAllPatientListMutation } from '../Patient/patientApi';
import { getSecureItem } from "../../utils/secureStorage";
const AddPatient = ({ setLoading, show, setShow, editData }) => {
    const { t } = useTranslation();
    const user = getSecureItem('UserData');
    const maxDateValidation = new Date().toISOString().split('T')[0];
    const config = {
        email: '',
        verifyEmail: '',
        password: 'SymInfo@#2024',
        mobile: '',
        userType: 'PATIENT',
        languageId: 1,
        name: '',
        lastName: '',
        dateOfBirth: '',
        doYouWearGlasses: '',
        whenIsTheLastTimeYouWentToTheEyeDoctor: '',
        patientNameOfYourUsualEyeDoctor: `${user?.name} ${user?.lastName}`,
        patientRppsNumberOfYourUsualEyeDoctor: 0,
        phoneNumber: 0,
        typeOfVision: '',
        patientHappy: '',
        patientSymptoms: '',
        patientDiagnosedWith: '',
        patientHealthConditions: '',
        additionalComments: '',
        doctorRppsNumber: '',
        doctorIdOfRegistration: '',
        doctorAddressOfTheHealthCenter: '',
        city: '',
        gender: '',
        age: '',
        SubmitTrack: 'Web',
        infoSSN: '',
        infoPrescriptionToOptician: true,
    };
    const [modalLoading, setModalLoading] = useState(false);
    const [error, setError] = useState('');
    const [validated, setValidated] = useState(false);
    const [addPatientConfig, setAddPatientConfig] = useState(config);
    const navigate = useNavigate();

    // Check if user is ADMIN or BACKOFFICE
    const isAdminOrBackoffice = user?.userType === "ADMIN" || user?.userType === "BACKOFFICE";
    const isEdit = Object.entries(editData).length > 0;

    useEffect(() => {
        setError('');
        setAddPatientConfig(
            Object.entries(editData).length > 0
                ? {
                      ...editData,
                      verifyEmail: editData.email,
                      dateOfBirth: formatDate(editData.dateOfBirth),
                  }
                : config
        );
        setEmailNotVerify(false);
        setAgeNotVerify(false);
        setValidated(false);
    }, [show]);

    const [emailNotVerify, setEmailNotVerify] = useState(false);
    const [isEmailExist, setIsEmailExist] = useState(false);
    const [ageNotVerify, setAgeNotVerify] = useState(false);
    const [addPatient] = useAddPatientMutation();
    const [editPatient] = useEditUserMutation();
    const [searchPatient] = useAllPatientListMutation();

    const handleChange = (e) => {
        e.preventDefault();
        const { name, value } = e.target;
        setAddPatientConfig((prevValues) => {
            const updatedValues = { ...prevValues, [name]: value };
            if (name === 'dateOfBirth') {
                if (value) {
                    let ageValue = getAge(value);
                    console.log('Age Value: ', ageValue);
                    updatedValues.age = ageValue.toString();
                } else {
                    updatedValues.age = '';
                }
            }
            if (name === 'doYouWearGlasses') {
                updatedValues.doYouWearGlasses = value == 'true' ? true : false;
            }
            if (name === 'infoPrescriptionToOptician') {
                updatedValues.infoPrescriptionToOptician = value == 'true' ? true : false;
            }
            return updatedValues;
        });
    };

    /**
     * Updating the "ageNotVerify" state, everytime when the change occurs in the age input
     */
    useEffect(() => {
        console.log('UseEffect for Age Verification Trigger - onChange');

        if (addPatientConfig.age) {
            if (addPatientConfig.age < 16) {
                setAgeNotVerify(true);
            } else {
                setAgeNotVerify(false);
            }
        }
    }, [addPatientConfig.age]);

    /**
     * Updating the "emailNotVerify" state, everytime when the change occurs in the Verify Email Input
     */
    useEffect(() => {
        console.log('UseEffect for Email Verification Trigger - onChange');

        if (addPatientConfig.verifyEmail) {
            if (
                matchEmails(
                    addPatientConfig.email,
                    addPatientConfig.verifyEmail
                )
            ) {
                setEmailNotVerify(false);
            } else {
                setEmailNotVerify(true);
            }
        }
    }, [addPatientConfig.verifyEmail]);

    const handleSubmit = async (event) => {
        event.preventDefault();
        const form = event.currentTarget;

        if (addPatientConfig.age < 16) {
            setAgeNotVerify(true);
            return;
        }
        if (matchEmails(addPatientConfig.email, addPatientConfig.verifyEmail)) {
            setEmailNotVerify(false);
            if (form.checkValidity()) {
                delete addPatientConfig.verifyEmail;
                setModalLoading(true);
                let result;
                if (Object.entries(editData).length > 0) {
                    result = await editPatient(addPatientConfig);
                } else {
                    result = await addPatient(addPatientConfig);
                }
                console.log(result.data, 'addPatientConfig', addPatientConfig);
                if (result.data) {
                    setShow(false);
                    navigate('/patient/view', {
                        state: {
                            userData: addPatientConfig.email,
                            editable: false,
                        },
                    });
                    setAddPatientConfig(config);
                    setLoading && setLoading(true);
                } else {
                    setAddPatientConfig((prevValues) => {
                        return {
                            ...prevValues,
                            verifyEmail: addPatientConfig.email,
                            age: parseInt(addPatientConfig.age),
                        };
                    });
                    setError(t('thisemailalreadyexists'));
                }
                setModalLoading(false);
            }
            setValidated(true);
        } else {
            setEmailNotVerify(true);
        }
    };

    return (
        <>
            <Modal
                show={show}
                size="lg"
                onHide={() => {
                    setAddPatientConfig(config);
                    setError('');
                    setShow(false);
                }}
                aria-labelledby="contained-modal-title-vcenter"
                backdrop="static"
                keyboard={false}
                centered
            >
                <Form noValidate validated={validated} onSubmit={handleSubmit}>
                    <Modal.Header closeButton>
                        <Modal.Title>
                            {isEdit ? t('edit') : t('addPatient')}
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body className="modal_form">
                        <Row>
                            <Col md={6}>
                                <Form.Group className="mb-3">
                                    <Form.Label>{t('firstName')}*</Form.Label>
                                    <Form.Control
                                        onChange={handleChange}
                                        value={addPatientConfig.name}
                                        type="text"
                                        name="name"
                                        placeholder={t('inputText')}
                                        required
                                    />
                                </Form.Group>
                            </Col>

                            <Col md={6}>
                                <Form.Group className="mb-3">
                                    <Form.Label>{t('surName')}*</Form.Label>
                                    <Form.Control
                                        onChange={handleChange}
                                        value={addPatientConfig.lastName}
                                        type="text"
                                        name="lastName"
                                        placeholder={t('inputText')}
                                        required
                                    />
                                </Form.Group>
                            </Col>
                            <Col md={6}>
                                <Form.Group className="mb-3">
                                    <Form.Label>{t('dateofBirth')}*</Form.Label>
                                    <Form.Control
                                        onChange={handleChange}
                                        max={maxDateValidation}
                                        value={addPatientConfig.dateOfBirth}
                                        type="date"
                                        name="dateOfBirth"
                                        placeholder={t('inputText')}
                                        required
                                    />
                                </Form.Group>
                            </Col>

                            <Col md={6}>
                                <Form.Group className="mb-3">
                                    <Form.Label>{t('age')}</Form.Label>
                                    <Form.Control
                                        onChange={handleChange}
                                        isInvalid={ageNotVerify}
                                        value={addPatientConfig.age}
                                        type="text"
                                        name="age"
                                        placeholder={t('inputText')}
                                        disabled
                                    />
                                    {ageNotVerify && (
                                        <Form.Control.Feedback type="invalid">
                                            {t('ageLimit')}
                                        </Form.Control.Feedback>
                                    )}
                                </Form.Group>
                            </Col>
                            <Col md={6}>
                                <Form.Group className="mb-3">
                                    <Form.Label>{t('email')}*</Form.Label>
                                    <Form.Control
                                        onChange={handleChange}
                                        isInvalid={emailNotVerify}
                                        value={addPatientConfig.email}
                                        type="text"
                                        name="email"
                                        placeholder={t('inputText')}
                                        disabled={isEdit}
                                        required
                                    />
                                    {emailNotVerify && (
                                        <Form.Control.Feedback type="invalid">
                                            {t('verifyEmail')}
                                        </Form.Control.Feedback>
                                    )}
                                </Form.Group>
                            </Col>

                            {!isEdit && (
                                <Col md={6}>
                                    <Form.Group className="mb-3">
                                        <Form.Label>
                                            {t('confirmEmail')}*
                                        </Form.Label>
                                        <Form.Control
                                            onChange={handleChange}
                                            isInvalid={emailNotVerify}
                                            type="text"
                                            value={addPatientConfig.verifyEmail}
                                            name="verifyEmail"
                                            placeholder={t('inputText')}
                                            required
                                        />
                                        {emailNotVerify && (
                                            <Form.Control.Feedback type="invalid">
                                                {t('verifyEmail')}
                                            </Form.Control.Feedback>
                                        )}
                                    </Form.Group>
                                </Col>
                            )}
                            <Col md={6}>
                                <Form.Group className="mb-3">
                                    <Form.Label>{t('phone')}*</Form.Label>
                                    <Form.Control
                                        onChange={handleChange}
                                        value={addPatientConfig.mobile}
                                        type="tell"
                                        name="mobile"
                                        placeholder={t('inputText')}
                                        required
                                    />
                                </Form.Group>
                            </Col>

                            <Col md={6}>
                                <Form.Group className="mb-3">
                                    <Form.Label>{t('gender')}*</Form.Label>
                                    <Form.Select
                                        aria-label="Default"
                                        name="gender"
                                        onChange={handleChange}
                                        value={addPatientConfig.gender}
                                        required
                                    >
                                        <option disabled value={''}>
                                            {t('selectItem')}
                                        </option>
                                        <option value="Male">
                                            {t('male')}
                                        </option>
                                        <option value="Female">
                                            {t('female')}
                                        </option>
                                        <option value="Others">
                                            {t('others')}
                                        </option>
                                    </Form.Select>
                                </Form.Group>
                            </Col>
                            {/* <Col md={6}>
                                <Form.Group className="mb-3">
                                    <Form.Label>{t('typeofVision')}</Form.Label>
                                    <Form.Select
                                        aria-label="Default"
                                        name="typeOfVision"
                                        onChange={handleChange}
                                        value={addPatientConfig.typeOfVision}
                                    >
                                        <option disabled value={''}>
                                            {t('selectItem')}
                                        </option>
                                        <option value="Far Vision">
                                            {t('farVision')}
                                        </option>
                                        <option value="Close Vision">
                                            {t('closeVision')}
                                        </option>
                                        <option value="Progressive Vision">
                                            {t('progressiveVision')}
                                        </option>
                                    </Form.Select>
                                </Form.Group>
                            </Col>

                            <Col md={6}>
                                <Form.Group className="mb-3">
                                    <Form.Label>
                                        {t('doesSubjectWearGlasses')}*
                                    </Form.Label>
                                    <Form.Select
                                        aria-label="Default"
                                        name="doYouWearGlasses"
                                        onChange={handleChange}
                                        value={
                                            addPatientConfig.doYouWearGlasses
                                        }
                                        required
                                    >
                                        <option disabled value={''}>
                                            {t('selectItem')}
                                        </option>
                                        <option value={true}>{t('yes')}</option>
                                        <option value={false}>{t('no')}</option>
                                    </Form.Select>
                                </Form.Group>
                            </Col> */}
                            
                            {/* Prescription shared automatically field - Only for edit mode and ADMIN/BACKOFFICE users */}
                            {isEdit && isAdminOrBackoffice && (
                                <Col md={6}>
                                    <Form.Group className="mb-3">
                                        <Form.Label>
                                            {t('Ordonnance partagée automatiquement') || 'Ordonnance partagée automatiquement'}
                                        </Form.Label>
                                        <Form.Select
                                            aria-label="Prescription shared automatically"
                                            name="infoPrescriptionToOptician"
                                            onChange={handleChange}
                                            value={addPatientConfig.infoPrescriptionToOptician ? 'true' : 'false'}
                                        >
                                            <option value="true">
                                                {t('yes') || 'Yes'}
                                            </option>
                                            <option value="false">
                                                {t('no') || 'No'}
                                            </option>
                                        </Form.Select>
                                    </Form.Group>
                                </Col>
                            )}
                            
                            <Col md={6}>
                                <Form.Group className="mb-3">
                                    <Form.Label>{t('ssnNumber')}</Form.Label>
                                    <Form.Control
                                        onChange={handleChange}
                                        value={addPatientConfig.infoSSN}
                                        name="infoSSN"
                                        placeholder={t('inputText')}
                                    />
                                </Form.Group>
                            </Col>
                            <Col md={12}>
                                <Form.Group className="mb-3">
                                    <Form.Label>
                                        {t('patientAdditionalComments')}
                                    </Form.Label>
                                    <Form.Control
                                        onChange={handleChange}
                                        value={
                                            addPatientConfig.additionalComments
                                        }
                                        as="textarea"
                                        name="additionalComments"
                                        rows={3}
                                        type="text"
                                        placeholder={t('inputText')}
                                    />
                                </Form.Group>
                            </Col>
                            <Col md={12}>
                                <Form.Group className="mb-3">
                                    <Form.Label>{t('address')}</Form.Label>
                                    <Form.Control
                                        onChange={handleChange}
                                        value={
                                            addPatientConfig.doctorAddressOfTheHealthCenter
                                        }
                                        as="textarea"
                                        name="doctorAddressOfTheHealthCenter"
                                        rows={3}
                                        type="text"
                                        placeholder={t('inputText')}
                                    />
                                </Form.Group>
                            </Col>
                            {error !== '' && (
                                <Col md={12}>
                                    <Alert variant={'danger'}>{error}</Alert>
                                </Col>
                            )}
                        </Row>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button
                            variant="secondary"
                            onClick={() => setShow(false)}
                        >
                            {t('cancel')}
                        </Button>
                        <Button
                            type="submit"
                            variant="primary"
                            disabled={modalLoading}
                        >
                            {modalLoading && (
                                <Spinner
                                    animation="border"
                                    role="status"
                                    size="sm"
                                >
                                    <span className="visually-hidden">
                                        Loading...
                                    </span>
                                </Spinner>
                            )}{' '}
                            {isEdit ? t('saveChanges') : t('addNewSheet')}
                        </Button>
                    </Modal.Footer>
                </Form>
            </Modal>
        </>
    );
};
export default AddPatient;